<template>
  <div class="card">
    <a @click="$router.go(-1)">
      <img
        style="width: 2rem; display: inline-flex; cursor: pointer;"
        src="../assets/back.svg"
        class="navigation-icon"
        alt
      />
    </a>
    <div
      :style="`--primary-color: ${data.color.hex}`"
      class="markdown"
      v-html="markdownString(data.richText)"
    ></div>
  </div>
</template>

<script>
import showdown from "showdown";

export default {
  name: "Card",
  data() {
    return {
      data: this.$route.params,
    };
  },
  methods: {
    markdownString(markdownString) {
      let converter = new showdown.Converter();
      let output;
      const editedRichText = markdownString.replace(
        /(https:\/\/media\.graphassets\.com\/)([A-Za-z0-9]+)/g,
        "$1resize=fit:crop,height:242,width:400/$2"
      );
      output = converter.makeHtml(editedRichText);
      return output;
    },
  },
};
</script>

<style lang="scss">
.markdown {
  p {
    margin-bottom: 1rem;
  }
  h1,
  h2,
  h3,
  h4 {
    color: var(--primary-color);
  }
}
</style>
